import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { verifyToken, isAuthenticated } = useAuth();
  const [isVerifying, setIsVerifying] = useState(true);
  const [isAuthed, setIsAuthed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const checkAuth = async () => {
      if (isAuthenticated()) {
        const result = await verifyToken();
        if (!cancelled) setIsAuthed(result.isValid);
      }
      if (!cancelled) setIsVerifying(false);
    };

    checkAuth();
    return () => {
      cancelled = true;
    };
  }, [verifyToken, isAuthenticated]);

  if (isVerifying) {
    return <div>Loading...</div>;
  }

  return isAuthed ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
